import { VideoPlayer2Translation, VideoPlayerManager2 } from "../types";

export const VIDE_PLAYER_2_DEFAULT_TRANSLATION: VideoPlayer2Translation = {
  auto: "Auto",
  play: "Play",
  pause: "Pause",
  forward: "Forward",
  rewind: "Rewind",
  replay: "Replay",
  speed: "Speed",
  volume: "Volume",
  mute: "Mute",
  unmute: "Unmute",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit Fullscreen",
  pictureInPicture: "Picture in Picture",
  exitPictureInPicture: "Exit Picture in Picture",
  settings: "Settings",
  quality: "Quality",
  loading: "Loading...",
  help: "Help",
  keyboardShortcuts: "Keyboard Shortcuts",
  volumeUpDown: "Volume up / down",
  doubleTapSeek: "Left: -10s, Right: +10s",
  holdFor2xSpeed: "Hold for 2x speed",
  clickFor2xSpeed: "Click/tap for 2x speed",
};

export function currentTimeCacheKey(player: VideoPlayerManager2) {
  return `vp2ct.${player.id}`; // vp2ct = video player 2 current time
}
